import { render, staticRenderFns } from "./StateMessages.vue?vue&type=template&id=53d73a58&"
import script from "./StateMessages.vue?vue&type=script&lang=js&"
export * from "./StateMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/soeren.lyhs/_htdocs/privat/meinbubu/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VContainer,VSnackbar})
